export default function ArrowBackIcon() {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8518 0.719198C11.6045 0.966527 11.6045 1.36753 11.8518 1.61486L13.304 3.06703H6.59964C3.45159 3.06703 0.899637 5.61901 0.899637 8.76703C0.899637 11.9151 3.45159 14.467 6.59964 14.467H11.6663C12.0161 14.467 12.2996 14.1834 12.2996 13.8337C12.2996 13.484 12.0161 13.2004 11.6663 13.2004H6.59964C4.15117 13.2004 2.1663 11.2155 2.1663 8.76703C2.1663 6.31856 4.15117 4.33369 6.59964 4.33369H13.304L11.8518 5.78586C11.6045 6.03319 11.6045 6.4342 11.8518 6.68152C12.0991 6.92887 12.5001 6.92887 12.7475 6.68152L15.2808 4.14819C15.5281 3.90086 15.5281 3.49986 15.2808 3.25253L12.7475 0.719198C12.5001 0.471856 12.0991 0.471856 11.8518 0.719198Z"
        fill="currentColor"
      />
    </svg>
  );
}
